import { Loading } from '@folio/stripes/components';
import React from 'react';
import { t } from '../../services';
import css from './CompilingLoader.modult.css';
export var CompilingLoader = function () {
    return (React.createElement("span", { className: css.compilerWrapper },
        React.createElement("span", null, t('lists.item.compiling')),
        React.createElement(Loading, null)));
};
